import { c as _c } from "react/compiler-runtime";
import { TourCardCarouselPaginationPropertiesType } from "@website/accommodation-ui/tour-card/tour-card-carousel/types";
import { FC } from "react";
export const TourCardCarouselPagination: FC<TourCardCarouselPaginationPropertiesType> = properties => {
  const $ = _c(5);
  const {
    length,
    currentIndex
  } = properties;
  let t0;
  if ($[0] !== length) {
    t0 = Array.from({
      length
    }).map(_temp);
    $[0] = length;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== currentIndex || $[3] !== t0) {
    t1 = <div className="bg-on-color-disable absolute bottom-4 right-1/2 z-20 flex translate-x-1/2 gap-1 rounded-full px-2.5 py-1 max-md:hidden">{t0.map(index_0 => <div className={`size-1.5 rounded-full ${currentIndex === index_0 ? "bg-on-surface-secondary-high-emphasis" : "bg-on-color-disable"}`} key={index_0} />)}</div>;
    $[2] = currentIndex;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(_, index) {
  return index;
}